import { useMytaverse } from '@providers/MytaverseProvider';

export const useUserName = () => {
  const { user } = useMytaverse();

  if (user.firstName) {
    return user.firstName;
  } else if (user.name) {
    return user.name;
  }
};
